// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.ContactsPage_header__24tHx {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #007bff;
  color: #fff;
  padding: 12px 16px;
}

.ContactsPage_title__8u52k {
  margin: 0;
  font-size: 1.2rem;
}

.ContactsPage_closeButton__fgxw- {
  background: none;
  border: none;
  color: #fff;
  font-size: 1.2rem;
  cursor: pointer;
}

.ContactsPage_body__We7Bs {
  padding: 16px;
  overflow-y: auto;
  flex: 1 1;
}

.ContactsPage_loading__ud9sy, .ContactsPage_error__Gr74P {
  text-align: center;
  color: #666;
}

.ContactsPage_commentBlock__8SB8Y {
  margin-bottom: 16px;
}

.ContactsPage_commentText__t\\+Nre {
  margin: 4px 0 0;
  color: #333;
  line-height: 1.4;
}

.ContactsPage_phoneButton__2fcrc {
  background: #007bff;
  color: #fff;
  border: none;
  padding: 4px 8px;
  margin: 0 2px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
}

.ContactsPage_phoneButton__2fcrc:hover {
  background: #0056b3;
}

.ContactsPage_footer__GXUsM {
  padding: 12px 16px;
  background: #f5f5f5;
  text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/CourierModal/styles/ContactsPage.module.css"],"names":[],"mappings":";;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":["\r\n\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background: #007bff;\r\n  color: #fff;\r\n  padding: 12px 16px;\r\n}\r\n\r\n.title {\r\n  margin: 0;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.closeButton {\r\n  background: none;\r\n  border: none;\r\n  color: #fff;\r\n  font-size: 1.2rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.body {\r\n  padding: 16px;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n}\r\n\r\n.loading, .error {\r\n  text-align: center;\r\n  color: #666;\r\n}\r\n\r\n.commentBlock {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.commentText {\r\n  margin: 4px 0 0;\r\n  color: #333;\r\n  line-height: 1.4;\r\n}\r\n\r\n.phoneButton {\r\n  background: #007bff;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 4px 8px;\r\n  margin: 0 2px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.phoneButton:hover {\r\n  background: #0056b3;\r\n}\r\n\r\n.footer {\r\n  padding: 12px 16px;\r\n  background: #f5f5f5;\r\n  text-align: right;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `ContactsPage_header__24tHx`,
	"title": `ContactsPage_title__8u52k`,
	"closeButton": `ContactsPage_closeButton__fgxw-`,
	"body": `ContactsPage_body__We7Bs`,
	"loading": `ContactsPage_loading__ud9sy`,
	"error": `ContactsPage_error__Gr74P`,
	"commentBlock": `ContactsPage_commentBlock__8SB8Y`,
	"commentText": `ContactsPage_commentText__t+Nre`,
	"phoneButton": `ContactsPage_phoneButton__2fcrc`,
	"footer": `ContactsPage_footer__GXUsM`
};
export default ___CSS_LOADER_EXPORT___;
